export default {
  superAdmin: { id: 1, name: 'super-admin' },
  orgAdmin: { id: 2, name: 'organization-admin', roleType: 'organization' },
  orgUser: { id: 3, name: 'organization-user', roleType: 'organization' },
  initiativeAdmin: { id: 4, name: 'initiative-admin', roleType: 'initiative' },
  initiativeManager: { id: 5, name: 'initiative-manager', roleType: 'initiative' },
  initiativeOrganizer: { id: 6, name: 'initiative-organizer', roleType: 'initiative' },
  initiativeAssignee: { id: 7, name: 'initiative-assignee', roleType: 'initiative' },
  dataAssignee: { id: 9, name: 'data-assignee', roleType: 'initiative' },
  petitionImageViewer: { id: 10, name: 'petition-image-viewer', roleType: 'initiative' },
  petitionUploader: { id: 11, name: 'petition-uploader', roleType: 'initiative' },
  auxiliaryTaskSpecialist: { id: 12, name: 'auxiliary-task-specialist', roleType: 'initiative' },
  reportViewer: { id: 13, name: 'report-viewer', roleType: 'initiative' },
  canvassingOrganizationUser: {
    id: 14,
    name: 'canvassing-organization-user',
    roleType: 'initiative',
  },
  electionOfficialAdmin: { id: 15, name: 'election-official-admin', roleType: 'initiative' },
  electionOfficialAssignee: { id: 16, name: 'election-official-assignee', roleType: 'initiative' },
};
